module.exports = __webpack_public_path__ + "static/img/histoire-07.eb65f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-07.png
// module id = 92
// module chunks = 0